import { Button } from "antd";
import { Modal } from "antd";
import { FC } from "react";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ResubmissionProcedureCghsNew from "./ResubmissionProcedureCghsNew";
import ReasonOfResubmissionCghsNew from "./ReasonOfResubmissionCghsNew";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";
import DocumentUploadResubmission from "../../Enhancement/CGHSNEW/DocumentUploadResubmission";

type ResubmissionCghsNewProps = {
  addNewResubmissionModal: boolean;
  handleCancel: () => void;
  closeCreateResubmissionModal: any;
  handleSubmit: any;
  isFetchingPortalData: boolean;
  resubmissionProcedure: any;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  patientDetails: IFetchAllDetails | null;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: CallableFunction;
  form: any;
  resubmissionReasonOptions: Array<{ label: string; value: string }>;
  reasonOfResubmissionForm?: any;
  documentTypes: Document[];
    documentUrls: {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType?: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks?: string | null;
    }[];
    handleFileChange: any;
    handleOpen: any;
    isFetchingBillDetails: any;
    isSubmitting: any;
    procedureForm: any;
};

const ResubmissionCghsNew: FC<ResubmissionCghsNewProps> = (props) => {
  return (
    <Modal
      open={props?.addNewResubmissionModal}
      title="Resubmission Case"
      centered
      width={1200}
      loading={props?.isFetchingPortalData || props?.isFetchingBillDetails}
      footer={[
        <Button key="back" onClick={props?.closeCreateResubmissionModal}>
          Cancel
        </Button>,

        <Button
          type="primary"
          htmlType="submit"
          style={{
            border: "1px solid #00549e",
            background: "#00549e",
            fontSize: "14px",
            fontWeight: "400",
            color: "white",
          }}
          loading={props?.isSubmitting}
          onClick={props?.handleSubmit}
        >
          SUBMIT
        </Button>,
      ]}
      onCancel={props?.closeCreateResubmissionModal}
      style={{ top: 20 }}
      className="new-add-enhancement"
    >
      <ResubmissionProcedureCghsNew
        resubmissionProcedure={props?.resubmissionProcedure}
        formattedAccreditationOptions={props?.formattedAccreditationOptions}
        formattedTreatingDoctorsOptions={props?.formattedTreatingDoctorsOptions}
        formattedProcedureReferral={props?.formattedProcedureReferral}
        formattedProceduresOptions={props?.formattedProceduresOptions}
        handleGetProcedureAmount={props?.handleGetProcedureAmount}
        handleGetProcedureStrats={props?.handleGetProcedureStrats}
        patientDetails={props?.patientDetails}
        procedureStrats={props?.procedureStrats}
        handleDeleteProcedure={props?.handleDeleteProcedure}
        isModalOpen={props?.isModalOpen}
        setIsModalOpen={props?.setIsModalOpen}
        handleOk={props?.handleOk}
        handleCancel={props?.handleCancel}
        form={props?.form}
        resubmissionReasonOptions={props?.resubmissionReasonOptions}
        isFetchingBillDetails={props?.isFetchingBillDetails}
        procedureForm={props?.procedureForm}
      />

      <ReasonOfResubmissionCghsNew
        reasonOfResubmissionForm={props?.reasonOfResubmissionForm}
        resubmissionReasonOptions={props?.resubmissionReasonOptions}
      ></ReasonOfResubmissionCghsNew>

      {/* <DocumentUploadResubmission
        documentTypes={props?.documentTypes}
        documentUrls={props?.documentUrls}
        handleFileChange={props?.handleFileChange}
        handleOpen={props?.handleOpen}
      /> */}
    </Modal>
  );
};

export default ResubmissionCghsNew;
